import React, { useContext, useState } from "react";
import { observer } from "mobx-react-lite";
import { useStore } from "../../stores/store";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AuthContext from "../../context/AuthProvider";
import { getNavigationByRole } from "../../config/navigation";
import useLogout from "../../hooks/useLogout";
import "./MainNavBar.css";

const MainNavBar = () => {
  const { t } = useTranslation();
  const { mainStore } = useStore();
  const navigate = useNavigate();
  const logout = useLogout();
  const { auth } = useContext(AuthContext);
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const categoryIcons = {
    "dashboard": "bi-speedometer2",
    "data-management": "bi-database-gear", 
    "visualization": "bi-graph-up-arrow",
    "analysis": "bi-cpu"
  };

  const renderNavigationItems = () => {
    const navigationCategories = getNavigationByRole(auth?.role);
    
    return navigationCategories.map((category, categoryIndex) => (
      <div key={category.category} className="nav-category-horizontal">
        <div className="dropdown">
          <button
            className="nav-category-btn"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <div className="nav-category-content">
              <i className={`${categoryIcons[category.category] || 'bi-grid-3x3-gap'} nav-category-icon`}></i>
              <span className="nav-category-text">{t(category.label)}</span>
              <i className="bi-chevron-down nav-category-arrow"></i>
            </div>
          </button>
          <ul className="dropdown-menu nav-dropdown">
            {category.items.map((item) => {
              const isActive = location.pathname === item.path || 
                              mainStore.menuNo === mainStore[item.menuProperty];
              
              return (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className={`dropdown-item nav-item-horizontal ${isActive ? "active" : ""}`}
                    title={t(item.displayNameKey)}
                  >
                    <i className={`${item.iconClass} nav-item-icon`}></i>
                    <span className="nav-item-text">{t(item.displayNameKey)}</span>
                    {isActive && <i className="bi-check-circle-fill nav-item-check"></i>}
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    ));
  };

  const renderMobileMenu = () => {
    const navigationCategories = getNavigationByRole(auth?.role);
    
    return (
      <div className={`mobile-menu ${isMenuOpen ? 'show' : ''}`}>
        {navigationCategories.map((category, categoryIndex) => (
          <div key={category.category} className="mobile-category">
            <div className="mobile-category-header">
              <i className={`${categoryIcons[category.category]} me-2`}></i>
              {t(category.label)}
            </div>
            {category.items.map((item) => {
              const isActive = location.pathname === item.path || 
                              mainStore.menuNo === mainStore[item.menuProperty];
              
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`mobile-nav-item ${isActive ? "active" : ""}`}
                  onClick={() => setIsMenuOpen(false)}
                >
                  <i className={`${item.iconClass} mobile-nav-icon`}></i>
                  <span className="mobile-nav-text">{t(item.displayNameKey)}</span>
                  {isActive && <i className="bi-check-circle-fill mobile-nav-check"></i>}
                </Link>
              );
            })}
          </div>
        ))}
      </div>
    );
  };

  return (
    <>
      <nav className="navbar-scientific">
        <div className="navbar-container">
          {}
          <div className="navbar-brand-section">
            <Link to="/Dashboard" className="navbar-brand-scientific">
              <div className="brand-logo-wrapper">
                <img 
                  src="/assets/img/eda.png" 
                  alt="M&A Analytics" 
                  className="brand-logo"
                />
              </div>
              <div className="brand-text-wrapper">
                <h4 className="brand-title">M&A Analytics</h4>
              </div>
            </Link>
          </div>

          {}
          <div className="navbar-nav-section">
            <div className="navbar-nav-wrapper">
              {renderNavigationItems()}
            </div>
          </div>

          {}
          <div className="navbar-actions-section">
            {}
            <div className="user-menu-wrapper">
              <div className="dropdown">
                <button
                  className="user-menu-btn"
                  type="button"
                  data-bs-toggle="dropdown"
                >
                  <i className="bi-person-circle"></i>
                  <span className="d-none d-lg-inline">Administrator</span>
                  <i className="bi-chevron-down"></i>
                </button>
                <ul className="dropdown-menu user-dropdown">
                  <li className="user-info">
                    <div className="user-avatar">
                      <i className="bi-person-circle"></i>
                    </div>
                    <div className="user-details">
                      <span className="user-name">Administrator</span>
                    </div>
                  </li>
                  <li><hr className="dropdown-divider" /></li>
                  <li>
                    <a className="dropdown-item user-menu-item" href="#">
                      <i className="bi-file-earmark-text"></i>
                      <span>Research Documentation</span>
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item user-menu-item" href="#">
                      <i className="bi-question-circle"></i>
                      <span>Help & Support</span>
                    </a>
                  </li>
                  <li><hr className="dropdown-divider" /></li>
                  <li>
                    <button
                      className="dropdown-item user-menu-item logout"
                      onClick={async () => { await logout(); navigate('/'); }}
                    >
                      <i className="bi-box-arrow-right"></i>
                      <span>Sign Out</span>
                    </button>
                  </li>
                </ul>
              </div>
            </div>

            {}
            <button
              className="mobile-menu-toggle"
              onClick={toggleMenu}
            >
              <span className={`hamburger ${isMenuOpen ? 'active' : ''}`}>
                <span></span>
                <span></span>
                <span></span>
              </span>
            </button>
          </div>
        </div>

        {}
        {renderMobileMenu()}
      </nav>
    </>
  );
};

export default observer(MainNavBar); 